module.exports = __webpack_public_path__ + "static/media/loading.4c140210.gif";